import type { QuantitySelectorVariant } from 'components/common/QuantitySelector/QuantitySelector.types';

export const MIN_COUNT = 1;

type CountArgs = {
  count: number;
  isIncrement: boolean;
  maxCount: number;
};

export const getCount = ({ count, maxCount, isIncrement }: CountArgs) => {
  const finalCount = isIncrement ? getIncrement({ count, maxCount }) : getDecrement(count);
  return finalCount;
};

const getIncrement = ({ count, maxCount }: { count: number; maxCount: number }) => {
  const incrementedCount = count + 1;

  if (incrementedCount <= maxCount) {
    return incrementedCount;
  }

  return count;
};

const getDecrement = (count: number) => {
  const decrementedCount = count - 1;

  if (decrementedCount >= MIN_COUNT) {
    return decrementedCount;
  }

  return count;
};

export const getIsDecrementDisabled = ({ count, variant }: { count: number; variant: QuantitySelectorVariant }): boolean | undefined => {
  if (count === 1 || getIsActionsDisabled({ variant })) {
    return true;
  }

  return undefined;
};

export const getIsIncrementDisabled = ({
  count,
  maxCount,
  variant
}: {
  count: number;
  maxCount: number;
  variant: QuantitySelectorVariant;
}): boolean | undefined => {
  if (count >= maxCount || getIsActionsDisabled({ variant })) {
    return true;
  }

  return undefined;
};

export const getIsActionsDisabled = ({ variant }: { variant: QuantitySelectorVariant }): boolean | undefined => {
  if (variant === 'disabled') {
    return true;
  }

  return undefined;
};
